exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tiles-grid-wrapper {\n  max-width: 100%;\n}\n.tiles-grid-wrapper img {\n  max-width: 100%;\n  object-fit: scale-down;\n}\n", ""]);

